import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './support/Array';
import './support/helpers';

import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faCheese,
  faHamburger,
  faIceCream,
  faMinus,
  faMugHot,
  faPizzaSlice,
  faPlus,
  faTimesCircle,
  faUtensils,
  faUtensilSpoon,
  faStar,
} from '@fortawesome/free-solid-svg-icons';

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(faTimesCircle);
library.add(faCheckCircle);
library.add(faMinus);
library.add(faPlus);
library.add(faIceCream);
library.add(faMugHot);
library.add(faUtensils);
library.add(faPizzaSlice);
library.add(faUtensilSpoon);
library.add(faHamburger);
library.add(faCheese);

library.add(faStar);

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#F16521',
});

window.App = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
